import React, { useState, useEffect } from 'react';
import { Button, Row, Col, Input, Empty, Typography, Spin } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import map from 'lodash/map';
import { SearchOutlined } from '@ant-design/icons';
import { Scrollbars } from 'react-custom-scrollbars';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Modal from '../../../components/Modal/index';
import { createBoxAction } from '../reducer/actions';
const { Paragraph } = Typography;

const { Search } = Input;

const SearchAddress = styled(Search)`
  &&& {
    border-radius: 12px;
    padding: 0 45px;
    height: 44px;
    background: white;
    .ant-input-suffix {
      display: none;
    }
    .ant-input {
      background: #f4f4f4;
    }
  }
`;
const Wrapper = styled.div`
  &&& {
    position: relative;
    .anticon-search {
      position: absolute;
      z-index: 1;
      font-size: 18px;
      top: 7px;
      left: 10px;
    }
  }
`;

function AddLock({
  visible,
  setVisible,
  locks,
  sectionName,
  sectionId,
  postBox,
  storageId,
  getBoxes,
  getDevices,
  updateDevice,
  box,
  setNewBox,
  setBoxNotLock,
  updateBox,
  setBoxId,
  setVisibleSetting,
  visibleSetting,
  source,
  user,
  loadingDevice,
  getTransactions,
  limit,
  cliendId,
}) {
  const [name, setName] = useState('');
  const [noName, setNoName] = useState(false);
  const { t } = useTranslation();
  const [currentValue, setCurrentValue] = useState(0);
  const dispatch = useDispatch();

  const createBox = (id) => {
    if (name === '') {
      setNoName(true);
    } else {
      dispatch(
        createBoxAction(
          {
            section_id: sectionId,
            name,
          },
          id,
          {
            getBoxes,
            query: {
              warehouse_id: storageId,
              transaction__client_id: source === 'customers' ? user.id : null,
            },
          },
        ),
      );
      setVisible(!visible);
    }
  };

  const attachLock = (id, idLock) => {
    if (name === '') {
      setNoName(true);
    } else {
      setVisibleSetting(true);
      setVisible(false);
      updateDevice(
        {
          box_id: id,
          id: idLock,
        },
        {
          sync: false,
          getSyncData: {
            fetchFunc: source === 'transaction' ? getTransactions : getBoxes,
            params: {
              limit: source === 'transaction' ? limit : null,
              warehouse_id: source === 'transaction' ? null : storageId,
              transaction__client_id:
                source === 'transaction'
                  ? null
                  : source === 'customers'
                  ? cliendId
                  : null,
            },
          },
        },
      );
    }
  };

  const createWithoutLock = () => {
    if (name === '') {
      setNoName(true);
    } else {
      postBox(
        {
          section_id: sectionId,
          name,
        },
        {
          sync: false,
          getSyncData: {
            fetchFunc: getBoxes,
            params: {
              warehouse_id: storageId,
              transaction__client_id: source === 'customers' ? user.id : null,
            },
          },
        },
      );
      setVisible(!visible);
    }
  };

  const onChange = (e) => {
    setName(false);
    setName(e.target.value);
    setCurrentValue(e.target.value);
  };

  const handleSearch = (value) => {
    getDevices({
      serial: value.toLowerCase().trim().replace(/\s/g, ''),
      box_id__is_null: 1,
    });
  };

  const handleChangeSearch = (e) => {
    if (e.target.value === '') {
      getDevices({
        box_id__is_null: 1,
      });
    }
  };

  const afterClose = () => {
    setCurrentValue(0);
    if (setNewBox) {
      setNewBox(false);
    } else if (setBoxNotLock) {
      setBoxNotLock(null);
    }
  };

  useEffect(() => {
    //lazy load devices
    if (visible) {
      getDevices({
        box_id__is_null: 1,
      });
    }
    if (box && source !== 'transaction') {
      setBoxId(box.id);
      setName(box.name)
    }
  }, [visible]);

  const onBlur = (e) => {
    if (e.target.value === '' && !box) {
      setNoName(true);
    } else {
      setNoName(false);
      updateBox(
        {
          name: e.target.value,
          id: box.id,
        },
        {
          sync: false,
          getSyncData: {
            fetchFunc: source === 'transaction' ? getTransactions : getBoxes,
            params: {
              limit: source === 'transaction' ? limit : null,
              warehouse_id: source === 'transaction' ? null : storageId,
              transaction__client_id:
                source === 'transaction'
                  ? null
                  : source === 'customers'
                  ? user.id
                  : null,
            },
          },
        },
      );
    }
  };

  return (
    <>
      <Modal
        afterClose={afterClose}
        visible={visible}
        width={553}
        setVisible={setVisible}
      >
        <div className="p-20">
          <Row type="flex" align="middle">
            <Col span={6}>
              <div className="flex">
                <span className="mb-0 mr-10 text-20 font-bold">{t('box')}</span>
                <div className="text-20 font-bold truncate">{sectionName}</div>
              </div>
            </Col>
            <Col span={17}>
              {box ? (
                <Input
                  onChange={onChange}
                  className="border rounded-xs border-input-border"
                  value={currentValue === 0 ? box.name : currentValue}
                  onBlur={onBlur}
                />
              ) : (
                <Input
                  onChange={onChange}
                  className="border rounded-xs border-input-border"
                />
              )}
              {noName ? (
                <div className="absolute right-0 text-red">
                  {t('enterBoxName')}
                </div>
              ) : null}
            </Col>
          </Row>
          <div className="mb-20 text-black font-medium mt-20">
            {t('takeLock')}
          </div>
          <Wrapper>
            <SearchOutlined />
            <SearchAddress
              onChange={handleChangeSearch}
              onSearch={handleSearch}
              icon={{
                top: '8px',
              }}
              style={{
                borderRadius: '8px',
                padding: '0 45px',
                height: '31px',
                background: '#f4f4f4',
                border: 'none',
              }}
              className="rounded-md"
              placeholder={t('selectTheMacAddressOfTheDevice')}
            />
          </Wrapper>
          <Spin spinning={loadingDevice}>
            <Scrollbars
              autoHeight
              autoHeightMin={77}
              autoHeightMax={300}
              renderTrackHorizontal={(props) => (
                <div
                  {...props}
                  className="track-horizontal"
                  style={{ display: 'none' }}
                />
              )}
              renderThumbHorizontal={(props) => (
                <div
                  {...props}
                  className="thumb-horizontal"
                  style={{ display: 'none' }}
                />
              )}
            >
              <div className="pt-20 pr-40 pb-20 pl-17 ">
                {locks ? (
                  locks.length !== 0 ? (
                    map(locks, (item) => {
                      return (
                        <Row
                          justify="space-between"
                          className="mb-20"
                          align="middle"
                          type="flex"
                        >
                          <Col span={4}>
                            <div
                              className={`${
                                !item.online ? 'bg-red' : 'bg-online'
                              } w-8 h-8 rounded-full absolute top-18 status -left-17`}
                            ></div>
                            <div className="text-graytext text-12 mb-4">
                              ID:
                            </div>
                            <div className="font-medium text-black">
                              {item.id}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div className="text-graytext text-12 mb-4">
                              {' '}
                              {t('macAdress')}:
                            </div>
                            <div className="font-medium text-black">
                              <Paragraph
                                className="font-medium text-black"
                                style={{ marginBottom: 0 }}
                                ellipsis
                              >
                                {item.serial}
                              </Paragraph>
                            </div>
                          </Col>
                          <Col span={4}>
                            <div className="text-graytext text-12 mb-4">
                              {t('firmware')}:
                            </div>
                            <div className="font-medium text-black">
                              {item.telemetry.version}
                            </div>
                          </Col>
                          <Col span={6}>
                            <Button
                              className="text-primary border-0 bg-btn-small hover:bg-btn-small"
                              size="small"
                              onClick={() => {
                                box
                                  ? attachLock(box.id, item.id)
                                  : createBox(item.id);
                              }}
                            >
                              {t('tieLock')}
                            </Button>
                          </Col>
                        </Row>
                      );
                    })
                  ) : (
                    <Empty />
                  )
                ) : (
                  <Empty />
                )}
              </div>
            </Scrollbars>
          </Spin>
          {source === 'new' ? (
            <div className="text-center">
              <Button
                onClick={() => {
                  createWithoutLock();
                }}
                type="primary"
                className="pl-3"
                type="link"
              >
                <span style={{ borderBottom: '1px dotted #4b97e9' }}>
                  {t('createWithoutLock')}
                </span>
              </Button>
            </div>
          ) : null}
        </div>
      </Modal>
    </>
  );
}

AddLock.propTypes = {};

export default AddLock;
